import Cookies from 'universal-cookie';

/**
 * Comprehensive function to clear all cookies and localStorage data used by the app
 * Uses efficient browser APIs when available, with fallbacks for comprehensive clearing
 */
export const clearAllAppData = () => {
  try {
    // Method 1: Use localStorage.clear() and sessionStorage.clear() for bulk clearing
    console.log('🧹 Clearing all localStorage...');
    localStorage.clear();

    console.log('🧹 Clearing all sessionStorage...');
    sessionStorage.clear();

    // Method 2: For cookies, we still need to clear them individually since there's no bulk clear API
    // However, we can get all cookies first and clear them more efficiently
    console.log('🧹 Clearing all cookies...');
    const cookies = new Cookies();

    // Get all cookies from document.cookie and clear them
    if (typeof document !== 'undefined' && document.cookie) {
      document.cookie.split(';').forEach(cookie => {
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
        if (name) {
          // Clear with multiple domain/path combinations to ensure complete removal
          cookies.remove(name);
          cookies.remove(name, { path: '/' });
          cookies.remove(name, { path: '/', domain: window.location.hostname });
          cookies.remove(name, { path: '/', domain: '.' + window.location.hostname });
          if (process.env.NEXT_PUBLIC_BASE_DOMAIN) {
            cookies.remove(name, { path: '/', domain: process.env.NEXT_PUBLIC_BASE_DOMAIN });
            cookies.remove(name, { path: '/', domain: '.' + process.env.NEXT_PUBLIC_BASE_DOMAIN });
          }
        }
      });
    }

    // Method 3: Clear additional browser storage APIs if available
    try {
      // Clear IndexedDB databases if any exist
      if ('indexedDB' in window) {
        indexedDB.databases?.().then(databases => {
          databases.forEach(db => {
            if (db.name) {
              indexedDB.deleteDatabase(db.name);
            }
          });
        }).catch(err => console.warn('Failed to clear IndexedDB:', err));
      }
    } catch (error) {
      console.warn('IndexedDB clearing not supported:', error);
    }

    try {
      // Clear Cache Storage if available
      if ('caches' in window) {
        caches.keys().then(cacheNames => {
          return Promise.all(
            cacheNames.map(cacheName => caches.delete(cacheName))
          );
        }).catch(err => console.warn('Failed to clear Cache Storage:', err));
      }
    } catch (error) {
      console.warn('Cache Storage clearing not supported:', error);
    }

    console.log('✅ All app data cleared successfully using browser APIs');

    // Optional: Force a page reload to ensure all data is cleared from memory
    // Uncomment the next line if you want to reload the page after clearing
    // window.location.reload();
  } catch (error) {
    console.error('❌ Failed to clear app data:', error);
  }
};
